import CardDesignerCardElementForeground from './CardDesignerCardElementForeground';

export default CardDesignerCardElementForeground;
